import { createFeature, createReducer, on } from '@ngrx/store';
import { EntityMeta, Item } from '@qtek/shared/models';
import { AgencyActions } from './agency.actions';

export interface AgencyState {
  allAgencies: Item[];
  agenciesMeta: EntityMeta;
}

const initialState: AgencyState = {
  allAgencies: [] as Item[],
  agenciesMeta: new EntityMeta(),
};

export const agencyReducer = createReducer(
  initialState,
  on(AgencyActions.getItemsSuccess, (state, { res, meta }) => ({
    ...state,
    allAgencies: res,
    agenciesMeta: meta,
  })),
  on(AgencyActions.createItemSuccess, (state, { res }) => ({
    ...state,
    allAgencies: [res].concat(state.allAgencies),
  })),
  on(AgencyActions.updateItemSuccess, (state, { res }) => {
    const newArr = state.allAgencies.slice();
    const index = newArr.findIndex(element => element.seqno === res.seqno);
    newArr[index] = res;

    return {
      ...state,
      allAgencies: newArr,
    };
  }),
  on(AgencyActions.deleteItemSuccess, (state, { res }) => ({
    ...state,
    allAgencies: state.allAgencies.filter(agency => agency.seqno !== res.seqno),
  })),
  on(AgencyActions.unsubscribeItem, state => {
    return {
      ...state,
      allAgencies: [] as Item[],
      agenciesMeta: new EntityMeta(),
    };
  })
);

export const AgencyFeature = createFeature({
  name: 'agency',
  reducer: agencyReducer,
});

export const { selectAllAgencies, selectAgenciesMeta } = AgencyFeature;
